import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardContent,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  Tooltip,
  Typography
} from '@mui/material';
import { Chart } from 'react-google-charts';
import moment from 'moment';
import 'moment/locale/pt-br';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { moneyFullFormat, percentualFormat } from '../../../../utils/format';
import { postTitulosAvencer } from '../../../../api/dashboard';
import LoaderMain from '../../../Onboarding/shared/LoaderMain';
import { exibeValorResumido } from '../../../../shared';
import { nivelUsuarioEnum } from '../../../../shared/Enums';

const Avencer = ({
  filtroDashboard,
  loadingDashFim,
  valorTotal,
  setValorTotal,
  valoresCalculados,
  qtdeClientes,
  setQtdeClientes,
  dadosUser
}) => {
  moment.locale('pt-br');

  const [dadosChart, setDadosChart] = useState(false);
  // const [valorTotal, setValorTotal] = useState(0);
  const [valorTotalPeriodo, setValorTotalPeriodo] = useState(0);
  const [filPeriodo, setFilPeriodo] = useState(7);
  const [isPending, setIsPending] = useState(false);
  const [diaAtual, setDiaAtual] = useState(false);
  const [diasCorridos, setDiasCorridos] = useState(false);

  const setDadosIniciais = () => {
    let hoje = moment();
    return [
      ['dia', 'Valores a vencer por data', 'Ticket médio'],
      [hoje.format('DD[/]MMM'), 0.0, 0],
      [hoje.add(1, 'day').format('DD[/]MMM'), 0.0, 0],
      [hoje.add(1, 'day').format('DD[/]MMM'), 0.0, 0],
      [hoje.add(1, 'day').format('DD[/]MMM'), 0.0, 0],
      [hoje.add(1, 'day').format('DD[/]MMM'), 0.0, 0],
      [hoje.add(1, 'day').format('DD[/]MMM'), 0.0, 0],
      [hoje.add(1, 'day').format('DD[/]MMM'), 0.0, 0]
    ];
  };

  const options = {
    title: null,
    width: '100%',
    height: '100px',
    chartArea: { width: '85%' },
    seriesType: 'bars',
    colors: ['#79BCFB'],
    series: { 1: { type: 'line', color: 'black' } },
    legend: { position: 'bottom', alignment: 'center' },
    animation: {
      duration: 1000,
      easing: 'out'
    },
    annotations: {
      alwaysOutside: true,
      isStacked: true,
      highContrast: true,
      textStyle: {
        color: '#1a284d',
        auraColor: 'transparent',
        bold: true
      }
    }
  };

  const opcoesSelect = [
    { label: 'Próximos 7 dias', valor: 7 },
    { label: 'Próximos 15 dias', valor: 15 }
  ];

  useEffect(() => {
    setDadosChart(setDadosIniciais());
    let hoje = moment();
    let dia = hoje.format('YYYY-MM-DD');
    setDiaAtual(dia);
    let diasCorridos = hoje.add(filPeriodo, 'day').format('YYYY-MM-DD');
    setDiasCorridos(diasCorridos);
  }, []);

  useEffect(() => {
    buscaDadosChart(filPeriodo);
  }, [filtroDashboard]);

  const buscaDadosChart = periodo => {
    let filtro = filtroDashboard ? filtroDashboard : {};
    if (filtro.filtrar === false) return false;

    let params = {
      periodo: periodo,
      ...filtro
    };

    setIsPending(true);
    setValorTotal(0);
    setQtdeClientes(0);
    setValorTotalPeriodo(0);
    setDadosChart(setDadosIniciais);
    postTitulosAvencer(params)
      .then(res => {
        let arrayDados = [];
        arrayDados.push([
          'dia',
          'Valores a vencer por data',
          { role: 'annotation' },
          'Ticket médio',
          { role: 'annotation' }
        ]);
        let valorTotal = res.data && res.data.valorTotal ? parseFloat(res.data.valorTotal) : 0;
        let qtdeClientes = res.data && res.data.qtdeClientes ? parseFloat(res.data.qtdeClientes) : 0;
        let valorTotalPer =
          res.data && res.data.valorTotalPeriodo ? parseFloat(res.data.valorTotalPeriodo) : 0;
        let lstTitulos = res.data && res.data.titulos ? res.data.titulos : [];
        lstTitulos.map(dados => {
          let dia = moment(dados.dataVencimento).format('DD[/]MMM');
          let valor = parseInt(dados.valor);
          let ticket = valor / parseInt(dados.qtd);
          ticket = parseInt(ticket);
          let ticketFormatado = ticket.toLocaleString('pt-br', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          });

          arrayDados.push([dia, valor, valor, ticket, ticketFormatado]);
          return dados;
        });

        if (valorTotal > 0) {
          setValorTotal(valorTotal);
        }

        if (valorTotalPer > 0) {
          setValorTotalPeriodo(valorTotalPer);
        }

        if (lstTitulos.length > 0) {
          setDadosChart(arrayDados);
        }

        if (qtdeClientes > 0) {
          setQtdeClientes(qtdeClientes);
        }
      })
      .catch(() => {
        setDadosChart(false);
      })
      .finally(() => {
        setIsPending(false);
        loadingDashFim('Avencer');
      });
  };

  const handleOnChangePeriodo = event => {
    setFilPeriodo(event.target.value);
    buscaDadosChart(event.target.value);
    let hoje = moment();
    let diasCorr = hoje.add(event.target.value, 'day').format('YYYY-MM-DD');
    setDiasCorridos(diasCorr);
  };

  return (
    <Card className="chart-card">
      {dadosChart ? (
        <CardContent className="ajuste-spin-chart" sx={isPending ? { position: 'relative' } : {}}>
          {isPending && <LoaderMain tipoLoader="float" tipoImagem="circulo" />}
          <Typography
            variant="subtitle1"
            className="texto-cor-cinza-escuro pad-5 word-break labelChartAvencer mb-1"
          >
            <span className="font-size-1rem margin-right-10 texto-weight-600 white-space-nowrap">
              Total à vencer
            </span>
            <Tooltip arrow placement="top" title={percentualFormat(valoresCalculados.avencer) + '%'}>
              <span className="font-size-1-2-rem texto-weight-600 texto-info white-space-nowrap">
                {`R$ ${exibeValorResumido(valorTotal)}`}
              </span>
            </Tooltip>
            {dadosUser && dadosUser.nivel !== nivelUsuarioEnum.CLIENTE && (
              <>
                <span className="font-size-1rem margin-right-10 white-space-nowrap">
                  &nbsp;&nbsp;&nbsp;&nbsp;Risco Médio
                </span>
                <Tooltip arrow placement="top" title={`Qtde clientes: ${qtdeClientes}`}>
                  <span className="font-size-1rem texto-info white-space-nowrap">
                    {`R$ ${exibeValorResumido(valorTotal / qtdeClientes)}`}
                  </span>
                </Tooltip>
              </>
            )}
          </Typography>
          <Grid container className="labelChartAvencer">
            <Grid
              item
              xl={3}
              lg={5}
              md={5}
              sm={5}
              xs={12}
              className="flex-box items-centralizados-esquerda"
            >
              <Select
                className="select-periodo-chart-dasboard"
                value={filPeriodo}
                onChange={handleOnChangePeriodo}
                input={<OutlinedInput label="" />}
              >
                {opcoesSelect.map(item => (
                  <MenuItem key={item.label} value={item.valor}>
                    <DateRangeIcon className="icone-select" />
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xl={7} lg={5} md={5} sm={5} xs={9}>
              <Typography
                variant="subtitle1"
                className="texto-cor-cinza-escuro pad-5 word-break labelChartAvencer mb-1 texto-esquerda"
              >
                <span className="font-size-1rem margin-right-10 white-space-nowrap">
                  Total / Período
                </span>
                <Tooltip arrow placement="top" title={moneyFullFormat(valorTotalPeriodo)}>
                  <span className="font-size-1-2-rem texto-weight-600 white-space-nowrap texto-cor-principal">
                    {`R$ ${exibeValorResumido(valorTotalPeriodo)}`}
                  </span>
                </Tooltip>
              </Typography>
            </Grid>
            <Grid
              item
              xl={2}
              lg={2}
              md={2}
              sm={2}
              xs={3}
              className="flex-box items-centralizados-direita"
            >
              <Link
                className="linkRelatorios float-right texto-info font-size-875"
                to={{
                  pathname: '/relatorios/titulos',
                  search: `?tipo=1&data_vencimento_inicial=${diaAtual}&data_vencimento_final=${diasCorridos}`,
                  state: {
                    fromDashboard: true
                  }
                }}
              >
                Relatório
              </Link>
            </Grid>
          </Grid>

          <Chart
            className="chartAvencer"
            chartType="ComboChart"
            width="100%"
            height="400px"
            data={dadosChart}
            options={options}
            chartLanguage="pt-Br"
          />
        </CardContent>
      ) : (
        <CardContent>
          <div className="error">
            <h1>Ops!</h1>
            <p>Alguma coisa deu errado, tente novamente mais tarde.</p>
          </div>
        </CardContent>
      )}
    </Card>
  );
};

export default Avencer;
